import { useSizeProp } from '@bigin/hooks'
import { buildProps, iconPropType } from '@bigin/utils'
import { Loading } from '@bigin/icons-vue'
import type { ExtractPropTypes } from 'vue'
import type button from './button.vue'

export const buttonTypes = [
  'default',
  'primary',
  'secondary',
  'ghost',
  'danger',
  'semi-danger',
  '',
] as const
export const buttonNativeTypes = ['button', 'submit', 'reset'] as const

export const buttonProps = buildProps({
  size: useSizeProp,
  disabled: Boolean,
  type: {
    type: String,
    values: buttonTypes,
    default: '',
  },
  prefixIcon: {
    type: iconPropType,
    default: '',
  },
  suffixIcon: {
    type: iconPropType,
    default: '',
  },
  icon: {
    type: iconPropType,
    default: '',
  },
  nativeType: {
    type: String,
    values: buttonNativeTypes,
    default: 'button',
  },
  loading: Boolean,
  loadingIcon: {
    type: iconPropType,
    default: () => Loading,
  },
  dark: Boolean,
  primary: Boolean,
  secondary: Boolean,
  ghost: Boolean,
  danger: Boolean,
  semiDanger: Boolean,
  rounded: Boolean,
  autofocus: Boolean,
  xlarge: Boolean,
  large: Boolean,
  small: Boolean,
  xsmall: Boolean,
  xxsmall: Boolean,
  tag: {
    type: String,
    default: 'button',
  },
} as const)
export const buttonEmits = {
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
}

export type ButtonProps = ExtractPropTypes<typeof buttonProps>
export type ButtonEmits = typeof buttonEmits

export type ButtonType = ButtonProps['type']
export type ButtonNativeType = ButtonProps['nativeType']

export type ButtonInstance = InstanceType<typeof button>

export interface ButtonConfigContext {
  autoInsertSpace?: boolean
}
